<template>
  <div>
    <!-- edo-tree-icon -->
    <div class="petition-counter" v-if="showHeader">
      <div class="edo-progress-bar">
        <div class="progress-bar-wrapper">
          <div
            class="progress-bar-inner"
            :style="{ width: 100 - progress + '%' }"
          ></div>
        </div>
        <div
          class="edo-tree-icon"
          :style="{ left: 'calc(' + progress + '% - 32px)' }"
        >
          <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/edo-tree-icon.svg" />
        </div>
      </div>
      <h2 v-if="showCounter">
        <count-to
          ref="counter"
          :startVal="startcounter"
          :end-val="currentCounter"
          :autoplay="false"
          :duration="7000"
          @callbackCounter="updatePercentage"
        ></count-to>
      </h2>
      <h5>{{ counterTitle }}</h5>
    </div>

    <div v-if="isActive" class="petition-form wwf-form light">
      <div class="flip-wrapper" :class="{ 'formValidation-shake': isShake }">
        <div class="petition-form">
          <p class="form-intro" v-if="intro">
            {{ intro }}
          </p>

          <div>
            <input
              name="firstName"
              type="text"
              v-model="firstName"
              v-validate="{ required: true }"
              :class="{ 'border-red': errors.has('firstName') }"
              placeholder="First name"
              autocomplete="given-name"
              v-on:focus="logFirstTouch('first name')"
            />
            <input
              name="lastName"
              type="text"
              v-model="lastName"
              v-validate="{ required: true }"
              :class="{ 'border-red': errors.has('lastName') }"
              placeholder="Last name"
              autocomplete="family-name"
              v-on:focus="logFirstTouch('last name')"
            />

            <!-- EMAIL -->
            <div class="with-input-loading">
              <input
                name="email"
                type="email"
                v-model="email"
                v-validate="{
                  required: true,
                  edoEmailIsValid: true,
                  email: true,
                }"
                :class="{ 'border-red': errors.has('email') }"
                placeholder="Email"
                @input="onEmailInput()"
                v-on:focus="logFirstTouch('email')"
              />
              <div
                class="input-loading"
                v-if="emailCheckSensis.checkEmailLoading"
              >
                <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/loading-tail-spin.svg" />
              </div>
              <span class="wwf-alert">
                <p v-if="errors.has('email')">{{ errors.first("email") }}</p>
              </span>
            </div>

            <!-- Postcode -->
            <input
              name="postcode"
              type="number"
              v-model="lead.postcode"
              placeholder="Postcode"
              v-validate="{ required: true }"
              :class="{ 'border-red': errors.has('postcode') }"
              v-on:focus="logFirstTouch('postcode')"
            />

            <!-- Phone Number -->
            <input
              name="phoneNumber"
              type="tel"
              v-model="phoneNumber"
              placeholder="Phone Number"
              v-validate="{ required: true, edoPhoneNumberIsValid: true }"
              :class="{ 'border-red': errors.has('phoneNumber') }"
              v-on:focus="logFirstTouch('phone')"
            />

            <!-- Custom Message -->
            <textarea
              name="message"
              placeholder="Your message. Writing a personalised message makes it harder for our politicians to ignore"
              v-model="lead.message"
              maxlength="255"
              :class="{ 'border-red': errors.has('message') }"
              v-on:focus="logFirstTouch('message')"
            ></textarea>
            <p class="word-count">
              {{ 255 - (lead.message ? lead.message.length : 0) + " Char" }}
            </p>

            <div class="input-checkbox">
              <input
                id="useMessage"
                type="checkbox"
                v-model="acceptToUseMessage"
              />
              <label for="useMessage">
                {{ concentUseMessage }}
              </label>
            </div>

            <!-- SUBMIT -->
            <button
              type="button"
              class="btn-submit"
              v-on:click="save()"
              :disabled="isSaving"
            >
              <span v-if="isSaving">Loading...</span>
              <span v-if="!isSaving">{{ submitButtonText }}</span>
            </button>

            <!-- READ LETTER BOTTOM -->
            <input
              type="button"
              class="read-letter"
              :value="viewLetterText"
              v-on:click="openReadLetterPage"
            />

            <div>
              <div class="signatures-title">Recent defenders</div>
              <last-signatures
                campaigId="edo"
                :numberOfSignatures="numberOfSignatures"
                iconSource="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/edo-signature-icon.png"
                classes="edo-signatures"
                action="became a defender"
              ></last-signatures>
            </div>

            <hr />

            <div class="privacy-statement">
              <p v-if="!isFromEDO">
                By signing you accept
                <a href="/privacy-policy/privacy-policy" target="_blank">
                  WWF-Australia&rsquo;s Privacy Policy.
                </a>
              </p>
              <p v-if="isFromEDO">
                By signing up to Defend the Unburnt Six you accept WWF’s project
                partner EDO’s
                <a
                  href="https://www.edo.org.au/privacy-policy/"
                  target="_blank"
                >
                  privacy policy
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
   <div v-if="!isActive" class="form-closed">
      <p>{{closingMessage}}</p>
    </div>
  </div> 
</template>

<script>
import firebase from "firebase";
import { Validator } from "vee-validate";
import countTo from "vue-count-to";
import progressbar from "../Progressbar.vue";
import { mapState } from "vuex";
import lastSignatures from "./../utils/LastSignatures";
import { getParameterByName } from "../../helpers";

const { detect } = require("detect-browser");
const browser = detect();

export default {
  name: "edo-form",
  components: {
    countTo,
    progressbar,
    lastSignatures,
  },
  data: function () {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      startcounter: 0,
      currentCounter: 0,
      error: false,
      isShake: false,
      timeout: null,
      acceptToUseMessage: false,
      isSaving: false,
      emailCheckSensis: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/,
      },
      leadKeepData: true,
      subscriptions: [],
      privacyPolicy: "wwf",
      progress: 0,
      curr: 100,

      formTouched: false,
    };
  },
  props: {
    // Header
    intro: {
      type: String,
    },
    counterLimit: {
      type: Number,
      default: 10000,
    },
    counterTitle: {
      type: String,
      default: "submitions",
    },
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    closingMessage: {
      type: String,
      default: "This petition has now closed."
    },
    datalayerName: {
      type: String,
      required: true,
      default: "edo",
    },

    // Lead (Marketo, IVE, ...)
    programName: {
      type: String,
      required: true,
    },
    nationBuilderTag: {
      type: String,
      default: "unburntsix-petition",
    },
    sendToIve: {
      type: Boolean,
      default: true,
    },
    iveSupplier: {
      type: String,
      default: "WWF-Aus-unburnt-six-phone-mandatory",
    },
    iveSource: {
      type: String,
      default: "EDO",
    },

    // Hide or show fields
    showHeader: {
      type: Boolean,
      default: true,
    },
    showCounter: {
      type: Boolean,
      default: false,
    },
    showViewLetter: {
      type: Boolean,
      default: true,
    },

    // Content
    submitButtonText: {
      type: String,
      default: "SIGN ME UP",
    },
    concentUseMessage: {
      type: String,
      default: "I accept that my message can be used",
    },
    viewLetterText: {
      type: String,
      default: "VIEW THE MESSAGE",
    },

    // Letter content
    letterTitle: {
      type: String,
      required: false,
    },
    letterMessage: {
      type: String,
      required: false,
    },

    // Thank you content
    wwfThankYouTitle: {
      type: String,
      default: "Thanks for protecting the unburnt six!",
    },
    wwfThankYouMessage: {
      type: String,
      default:
        "Defending these precious habitats is crucial in the fight against extinction. Your voice is vital to ensuring they are protected.",
    },
    maxFileSize: {
      type: Number,
      default: 40,
    },

    numberOfSignatures: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    ...mapState({
      lead: (state) => state.campaign.edo,
      user: (state) => state.auth.user,
    }),
    isFromEDO() {
      return this.privacyPolicy === "edo";
    },
  },
  created: async function () {
    this.subscriptions.push(
      await firebase
        .firestore()
        .collection("campaigns")
        .doc(this.datalayerName)
        .onSnapshot(
          (snapshot) => {
            this.currentCounter = snapshot.data().count;
            this.$refs.counter.count(this.currentCounter);
          },
          (error) => {
            console.error(err);
          }
        )
    );

    // Check the email
    let edoEmailIsValid = (email) => {
      return new Promise((resolve, reject) => {
        Promise.all([this.checkEmailDuplicate(), this.checkEmail()])
          .then((results) => {
            for (const r of results) {
              if (!r.valid) {
                return resolve(r);
              }
            }
            this.errors.remove("email");
            resolve({ valid: true });
          })
          .catch((err) => {
            console.error(err);
            this.errors.remove("email");
            resolve({ valid: true });
          });
      });
    };

    Validator.extend("edoEmailIsValid", {
      validate: edoEmailIsValid,
      getMessage: (field, params, data) => data.message,
    });

    // Check Phone Number
    let edoPhoneNumberIsValid = (phoneNumber) => {
      const validationRegex = /^(\+?61|0)([0-9]{8,9})/;
      if (!phoneNumber.replace(/ /g, "").match(validationRegex)) {
        return {
          valid: false,
          data: { message: "Invalid phone number" },
        };
      } else {
        return {
          valid: true,
        };
      }
    };

    Validator.extend("edoPhoneNumberIsValid", {
      validate: edoPhoneNumberIsValid,
      getMessage: (field, params, data) => data.message,
    });

    // Read query params to define the right privacy policy
    const o = getParameterByName("o");
    if (o === "edo") {
      this.privacyPolicy = "edo";

      let cnt = 0;
      let updateHeaderInterval = setInterval(() => {
        let nav = document.querySelector("nav");

        if (nav) {
          nav.classList.add("edo-hide-nav");
        }

        let navCenter = document.querySelector(".desktop-menu ul.hmenu");
        if (navCenter && navCenter.style.display !== "none") {
          navCenter.style.display = "none";
        }

        // Hide the navigation
        let navBackground = document.querySelector(
          ".desktop-menu ul.hmenu.right"
        );
        if (navBackground) {
          navBackground.style.display = "none";
        }

        if (
          (navCenter.style.display === "none" &&
            navBackground.style.display === "none" &&
            nav.classList.contains("edo-hide-nav")) ||
          ++cnt >= 50
        ) {
          clearInterval(updateHeaderInterval);
        }
      }, 200);

      let ele = document.querySelector("nav");

      ele = document.querySelector(".user-bttns");
      if (ele) {
        ele.style.display = "none";
      }

      ele = document.querySelector(".open-menu-ub");
      if (ele) {
        ele.style.display = "none";
      }

      ele = document.querySelector(".c-hamburger");
      if (ele) {
        ele.style.display = "none";
      }

      ele = document.querySelector(".mob-mbar");
      if (ele) {
        ele.style.background = "transparent";
        ele.style.top = "-40px";
      }
    }
  },
  mounted: function () {
    if (this.showCounter && this.$refs.counter) {
      this.$refs.counter.start();
    }

    // Fetch the content of the messages
    if (this.letterMessage) {
      this.$store
        .dispatch("getContentMessageById", this.letterMessage)
        .then((value) => {
          if (value) {
            this.letterContent = value.content;
          } else {
            this.letterContent = "";
          }
        });
    }
  },
  beforeDestroy: function () {
    // Unsubscript from all subscriptions
    for (const s of this.subscriptions) {
      s();
    }
  },
  methods: {
    updatePercentage(val) {
      const curr = Math.abs(val);

      if (curr === this.curr) {
        return;
      }

      this.curr = curr;
      let percent = (val / this.counterLimit) * 100;
      if (percent > 100) {
        percent = 100;
      }
      this.progress = percent;
    },
    onEmailInput: function () {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // Only call if not input for 500 ms
      this.timeout = setTimeout(() => {
        this.checkEmailDuplicate()
          .then((result) => {
            if (!result.valid) {
              this.errors.add({
                field: "email",
                msg: "Your email has already been submitted",
              });
            }
          })
          .catch((err) => {
            // If it fails, let the user free to continue
            console.log(err);
          });
      }, 500);
    },
    checkEmailDuplicate: function () {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("checkEmail", {
            campaignId: this.datalayerName,
            email: this.email,
          })
          .then((result) => {
            if (result) {
              resolve({
                valid: false,
                field: "email",
                data: { message: "Your email has already been submitted" },
              });
            } else {
              resolve({ valid: true });
            }
          });
      });
    },
    checkEmail: function () {
      return new Promise((resolve, reject) => {
        let timestamp = Date.now(); // timestamp for this api call
        this.emailCheckSensis.lastTimestamp = timestamp; // 1 , 2 , 3
        this.emailCheckSensis.checkEmailLoading = true;
        // Fetch Suggestions
        this.$store
          .dispatch("validateEmail", this.email)
          .then((response) => {
            if (response && timestamp >= this.emailCheckSensis.lastTimestamp) {
              this.emailCheckSensis.checkEmailLoading = false;
              resolve(response);
            }
          })
          .catch((err) => {
            console.error(err);
            this.emailCheckSensis.checkEmailLoading = false;
            // If it fails, let the user free to continue
            resolve({ valid: true });
          });
      });
    },
    openReadLetterPage: function () {
      this.$store.commit("setPopupContent", {
        title: this.letterTitle,
        message: this.letterContent,
        shareButton: false,
        recommendedReading: false,
        component: null,
        componentparams: null,
      });
      this.$store.commit("openPetitionMessagePopup", true);
    },
    save: function () {
      // Exit the function if it's busy
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      const postBody = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        postcode: this.lead.postcode,
        message: this.lead.message,
        phone: this.phoneNumber,
        programName: this.programName,
        acceptToUseMessage: this.acceptToUseMessage,
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: this.leadKeepData,
        nationBuilderTag: this.nationBuilderTag,
        sendToIve: this.sendToIve,
        iveSupplier: this.iveSupplier,
        iveSource: this.iveSource,
        isFromEDO: this.isFromEDO,
        origin: this.privacyPolicy,
        ssoId: this.$store.getters.ssoId,
        sourceUrl: window.location.href
      };

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      console.log(postBody);

      this.$validator.validate().then(async (result) => {
        if (result) {
          // Purify the inputs
          const results = await Promise.all([
            this.$store.dispatch("purifyText", this.firstName),
            this.$store.dispatch("purifyText", this.lastName),
            this.$store.dispatch("purifyText", this.lead.message),
          ]);
          const inError = results.filter((e) => e === false);
          const isPure = inError.length === 0;

          if (isPure) {
            this.saveLead(postBody);

            // Log step to Amplitude
            this.$store.dispatch("logPetitionSupporter", {
              id: postBody.programName,
              postcode: postBody.postcode,
            });
          } else {
            this.formInvalid();
          }
        } else {
          this.formInvalid();
        }
      });
    },
    formInvalid: function () {
      console.log("form invalid");
      // GTM Tracking
      if (window.dataLayer != undefined) {
        window.dataLayer.push({
          formName: this.datalayerName,
          event: "formSubmitEvent",
        });
      }
      this.isSaving = false;
      this.isShake = true;

      setTimeout(
        function () {
          this.isShake = false;
        }.bind(this),
        500
      );
    },
    async saveLead(postBody) {
      try {
        const data = {
          campaignId: this.datalayerName,
          lead: postBody,
          saveSignature: true,
          isFromEDO: this.isFromEDO,
        };
        await this.$http.post(`${wwfconfigs.WEB_API}/campaign/edo`, data);

        console.log("EDO submit success");

        if (window.dataLayer != undefined) {
          window.dataLayer.push({
            formName: this.datalayerName,
            event: "formSubmitSuccessEvent",
          });
        }

        this.lead.firstName = this.firstName;
        this.lead.lastName = this.lastName;
        this.lead.email = this.email;
        this.lead.phoneNumber = this.phoneNumber;

        // Reset form
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.lead.message = "";
        this.lead.postcode = "";
        this.phoneNumber = "";
        this.isSaving = false;
        this.acceptToUseMessage = false;

        // Open thank you popup
        this.openThankYouPopup();

        // Log registration to Amplitude
        this.$store.dispatch("logPetitionComplete", {
          id: this.programName,
          count: this.currentCounter,
        });
      } catch (err) {
        console.error(err);
        console.error("EDO submit failed");
        this.isSaving = false;
      }
    },
    openThankYouPopup() {
      const stepupId = getParameterByName("stepup");
      // Check query params for step up override
      if (stepupId) {
        this.$store
          .dispatch("getContentMessageById", stepupId)
          .then((response) => {
            const title = response.description;
            const content = response.content;

            this.$store.commit("setPopupContent", {
              component: "step-up",
              componentparams: {
                id: stepupId,
                title,
                content,
              },
            });

            this.$store.commit("openStepUpPopup", true);

            // Log to amplitude
            this.$store.dispatch("logStepUp", stepupId);
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        // If no step up, continue with thank you popup
        this.$store.commit("setPopupContent", {
          component: "edo-popup",
          componentparams: {
            layout: this.privacyPolicy,
            wwfThankYouTitle: this.wwfThankYouTitle,
            wwfThankYouMessage: this.wwfThankYouMessage,
            maxFileSize: this.maxFileSize,
          },
          showHeader: !this.isFromEDO,
        });

        this.$store.commit("openCustomContentPopup", true);
      }
    },
    logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logPetitionBegin", {
          id: this.programName,
          fieldName,
          count: this.currentCounter,
        });
        this.formTouched = true;
      }
    },
  },
};
</script>

<style>
.edo-signatures .signature .user-name {
  color: var(--wwfRegenerateFontColor);
  font-family: "Open sans";
}

.form-container.wwf-form.edo-form {
  box-shadow: 0px 4px 114px rgba(0, 0, 0, 0.18);
}

.desktop-menu.edo-hide-nav::before {
  background-color: transparent;
}
</style>

<style lang="css" scoped>
.signatures-title {
  margin: 10px 0;
  color: var(--wwfRegenerateFontColor);
  font-family: "Open sans";
  font-weight: 600;
}

.petition-counter {
  margin: -20px -20px 40px;
  padding: 40px 40px 0px;
  border-bottom: 1px solid var(--wwfGreyDE);
  background-color: var(--wwfBrandBlack);
}

.petition-counter .header-intro {
  margin-bottom: 16px;
}

.petition-counter hr {
  border: 1px solid var(--wwfWhite);
  opacity: 0.4;
}

span.wwf-alert {
  position: absolute;
  display: block;
  text-align: left;
  width: 100%;
  pointer-events: none;
  z-index: 9;
}

span.wwf-alert p {
  position: relative;
  background-color: var(--errorColor);
  left: 0;
  top: -18px;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  padding: 5px 10px;
  line-height: normal;
  border-radius: 3px;
  color: var(--wwfWhite);
  font-size: 13px;
  box-shadow: 0 3px 13px var(--wwfTransparentBlack020);
  z-index: 10;
  font-weight: 600;
}

.btn-submit:disabled {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

.input-loading {
  top: 6px;
}

.petition-form.wwf-form input[type="button"]:hover {
  background-color: var(--wwfDarkBlue);
  color: var(--wwfWhite);
}

/* FORM ADAPTATION */

.petition-form.wwf-form input[type="button"].read-letter {
  color: var(--wwfRegenerateAustralia);
  background-color: var(--wwfWhite);
  border: 1px solid var(--wwfRegenerateAustralia);
}

.petition-form.wwf-form input[type="button"].read-letter:hover {
  background-color: var(--wwfWhite);
  border: 1px solid var(--wwfRegenerateAustralia);
}

.petition-form.wwf-form {
  padding: 20px;
}

.wwf-form.light input,
.wwf-form.light textarea,
.wwf-form.light select {
  background-color: var(--wwfWhite);
  border: 1px solid var(--wwfGreyA7);
}

.wwf-form button {
  padding: 18px;
  width: 100%;
  margin-bottom: 1em;
  font-family: "Open sans";
  font-weight: 500;
  letter-spacing: 1px;
}

.wwf-form.light input,
.wwf-form.light textarea,
.wwf-form.light select {
  padding: 12px 16px;
  font-size: 15px;
  border-color: var(--wwfGreyC8);
}

.wwf-form.light input::placeholder,
.wwf-form.light textarea::placeholder,
.wwf-form.light select::placeholder {
  color: var(--wwfGrey82);
}

.wwf-form .word-count {
  color: var(--wwfGrey82);
}

/* Color Theme */
.petition-counter {
  background-color: var(--wwfRegenerateAustralia);
}

.petition-counter h2,
.petition-counter h5,
.petition-counter p.header-intro {
  width: 100%;
  color: var(--wwfWhite);
  text-align: center;
}

.petition-counter h2 {
  font-size: 100px;
}

.petition-counter h5 {
  font-size: 20px;
  line-height: 30px;
  margin-top: 20px;
  margin-bottom: 40px;
  font-weight: 600;
  letter-spacing: 1px;
  font-family: "Lato", sans-serif;
}

.petition-counter hr {
  border-color: var(--wwfRegenerateFontColor);
}

.wwf-form button.btn-submit {
  height: 48px;
  color: var(--wwfWhite);
  background-color: var(--wwfRegenerateAustralia);
}

.wwf-form.dark button:hover,
.wwf-form.dark input[type="button"]:hover,
.wwf-form.light button:hover,
.wwf-form.light input[type="button"]:hover {
  background-color: var(--wwfGreyA7);
}

button.btn-submit:hover {
  background-color: var(--wwfGreyA7);
}

.wwf-form .input-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.wwf-form .input-checkbox input {
  margin: 0;
}

.wwf-form .input-checkbox label {
  line-height: 20px;
}

/* PROGRESS BAR */
.edo-progress-bar {
  position: relative;
  height: 64px;
}

.edo-tree-icon {
  position: absolute;
  width: 64px;
  height: 64px;
  top: 0;
  left: -32px;
}

.progress-bar-wrapper {
  position: absolute;
  width: 100%;
  height: 14px;
  padding: 3px;
  margin: 25px 0;
  background-color: var(--wwfWhite);
  border-radius: 7px;
}

.progress-bar-inner {
  float: right;
  background-color: var(--wwfRegenerateAustralia);
  width: 100%;
  height: 100%;
  border-radius: 7px;
}

@media only screen and (max-width: 40em) {
  .petition-counter {
    margin: -20px -20px 40px;
    padding: 20px 20px 0px;
  }

  .petition-form.wwf-form {
    padding: 0;
  }
}
</style>


// WEBPACK FOOTER //
// Edo.vue?0debe6a2